import type {
  ReferralActivityItem,
  ReferralHistoryStats,
} from '@/types/referral';
import { Share2, TrendingUp } from 'lucide-react';
import { ActivityFeed } from './activity-feed';
import { LeaderboardCard } from './leaderboard-card';
import { StreakCard } from './streak-card';

interface ActivityPanelProps {
  activity: ReferralActivityItem[];
  stats: ReferralHistoryStats;
  vendorName: string;
  fomoMessage: string;
  onShare: () => void;
}

export const ActivityPanel = ({
  activity,
  stats,
  vendorName,
  fomoMessage,
  onShare,
}: ActivityPanelProps) => {
  return (
    <>
      <div className="fomo">
        <TrendingUp
          className="size-6 shrink-0"
          style={{ color: 'var(--rne-neon-green)', position: 'relative' }}
        />
        <div className="body">
          <p>{fomoMessage}</p>
        </div>
        <button type="button" className="btn-mint" onClick={onShare}>
          <Share2 className="size-4" />
          Share now
        </button>
      </div>

      <div className="alive-grid">
        <ActivityFeed activity={activity} />
        <div className="stack">
          <StreakCard
            activity={activity}
            totalReferrals={stats.totalReferrals}
          />
          <LeaderboardCard
            vendorName={vendorName}
            totalReferrals={stats.totalReferrals}
            totalEarnings={stats.totalEarnings}
          />
        </div>
      </div>
    </>
  );
};
